import * as common from './Common';

export class AppService {
    public isDebug=false;

    public userModel: UserModel = null;

    public deviceToken:string;
    public uiLocation = 'loading';

    public locationChanged = new common.ViewModelEvent<() => void>();
    public newLogAdded = new common.ViewModelEvent<(log:string) => void>();
    public newMessageAdded = new common.ViewModelEvent<(log:string) => void>();
    public onUIRefreshing = new common.ViewModelEvent<() => void>();    

    public onRequireKeyboardCode = new common.ViewModelEvent<() => void>();    

    public refreshUI(){
        this.onUIRefreshing.invoke();
    }

    public navigateTo(location: string) {
        this.uiLocation = location;
        this.locationChanged.invoke();
    }    

    public showMessage(message:string){
        this.newMessageAdded.invoke(message);
    }

    public showQuickMessage(message:string, duration=800){
        this.newMessageAdded.invoke(message);

        setTimeout(()=>{
            this.closeMessage();
        },duration);
    }

    public closeMessage(){
        this.newMessageAdded.invoke('');
    }

    public getUserModel(): Promise<void> {
        var promise = new Promise<void>((resolve, reject) => {
            common.callHttp('GET', 'user/getuser').then((data: any) => {
                if (!data) {
                    reject();
                } else {
                    this.userModel = {
                        username: data.Username,
                        nickname: data.Nickname,
                        password: data.password
                    };
                    resolve();
                }
            }, error => {
                this.userModel = null;
                reject(error);
            });
        });

        return promise;
    }

    public requestDeviceToken() {
        let webKit = window['webkit'] as any;
        if (webKit && webKit.messageHandlers && webKit.messageHandlers.requestDeviceToken) {
            webKit.messageHandlers.requestDeviceToken.postMessage({});
        }
    }

    public setDeviceToken(value: string) {
        this.deviceToken=value;
        this.log('token: '+value);
        common.callHttp('POST', 'devicetoken', value).then(() => {
        }, error => {
            // debug(error);
        });
    }

    private log(message:string){
        this.newLogAdded.invoke(message);
    }
}

export var appService = new AppService();

window['appService'] = appService;

export class UserModel {
    public username = '';
    public nickname='';
    public password = '';
}